import { FETCH_STATUS } from "../../actions/types";
import moment from "moment";
import { find, map, get } from "lodash";
import alarms from "../../constants/alarms";
import { getBits, isBitfield } from '../../helpers/getStatus';

const INITIAL_STATE = {
  results: []
};

export function getAlarmById(alarmId) {
  return find(alarms.status, ({ id }) => {
      return id === alarmId;
    }
  );
}

const getIndexRight = (bits, key, defaultValue) => {
  const targetIndex = bits.length - 1 - key;
  return get(bits, `[${targetIndex}]`, defaultValue);
};

const getBitfieldContent = ({ decode, desc }, { id, bits }) => ({
  alarmName: desc || id,
  values: map(decode, ((value, key) => ({
    title: value,
    value: !!parseInt(
      getIndexRight(
        bits,
        parseInt(key, 10),
        0
      ), 10
    )
  })))
});

function getValueContent(alarm, item) {
  return {
    alarmName: (alarm && alarm.desc) || item.id,
    alarmValue: (alarm && alarm.decode[item.value]) || item.value
  };
}

function getRawContent(alarm, item) {
  return {
    alarmName: (alarm && alarm.desc) || item.id,
    alarmValue: item.value
  };
}

export function populateAlarmContent(item) {
  const alarm = getAlarmById(item.id) || item;

  switch (alarm.type) {
    case 'bitfield':
      return getBitfieldContent(alarm, item);
    case 'value' :
      return getValueContent(alarm, item);
    default :
      return getRawContent(alarm, item);
  }
}

function formatResults(originalResults) {
  // TODO deepClone originalResults
  const results = [...originalResults];
  results.forEach(item => {
    item.displayTimestamp = moment(item.timestamp).format(
      "DD/MM/YYYY, HH:mm"
    );

    if (isBitfield(item)) {
      item.bits = getBits(item);
    }

    // Convert Alarm and event ID to Human readable strings
    Object.assign(item, populateAlarmContent(item));
  });
  return results;
}

const statusReducer = (state = INITIAL_STATE.results, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_STATUS:
      return formatResults(payload.data.results);
    default:
      return state;
  }
};

export default statusReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/status_reducer.js